<template>
    <div class="card">
        <div class="card-header border-bottom">
            <i class="fas fa-users me-2"></i>{{ TR.users }}
        </div>

        <div class="card-body">
            <DADataTable
                ref="user_table_ref"
                v-if="tableData"
                :tableData="tableData"
                :tableOptions="tableOptions"
            />
        </div>
    </div>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    import moment from "moment-timezone";

    import { G, ajax } from "@/_common";
    // import { FilterMatchMode } from 'primevue/api';
    import { FilterMatchMode } from '@primevue/core/api';
    import DADataTable from "@/components/table/DADataTable";

    export default {
        title: "users",
        name: 'UsersPage',
        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();

            const tableData = ref([]);
            const tableOptions = ref();
            const roles = ref([]);
            const user_table_ref = ref();
            const TR = ref({});

            onMounted(async () => {
                await ajax({
                    url: store.getUsers(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            // res.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime'])));
                            tableData.value = res;
                        } else {
                            // G.removeClientData("AUTH_TOKEN");
                        }
                    }
                });

                await ajax({
                    url: store.getRolesList(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            if( !G.userHavePermission("add") || G.privateIfNotAdmin() )
                                roles.value = res.filter(e => e.slug != 'admin').map((a) => {
                                    return { value: a.id, label: a.name, slug: a.slug };
                                });
                            else
                                roles.value = res.map((a) => {
                                    return { value: a.id, label: a.name, slug: a.slug };
                                });
                        }
                    }
                });

            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    row_total: false,
                    // rows: 5,
                    // row_class: (data) => {
                    //     return (G.hideAdminRecord(data) ? 'd-none' : '');
                    // },
                    header_buttons:[
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: 'fas fa-plus me-1',
                            class: 'btn-primary',
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    page: 'components/table/DynamicTable2',
                                    modal_width: 35,
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "username",
                                            title: TR.value.username,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "password",
                                            title: TR.value.users_password,
                                            field_type: "password",
                                            required: true,
                                        },
                                        {
                                            name: "password1",
                                            title: TR.value.users_repeat_password,
                                            field_type: "password",
                                            required: true,
                                        },
                                        {
                                            name: "email",
                                            title: TR.value.email,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "firstname",
                                            title: TR.value.firstname,
                                            field_type: "text",
                                        },
                                        {
                                            name: "lastname",
                                            title: TR.value.lastname,
                                            field_type: "text",
                                        },
                                        {
                                            name: "roles_id",
                                            title: TR.value.role,
                                            // value: (e) => e.roles_id,
                                            field_type: "dropdown",
                                            dropdown_items: roles.value,
                                            dropdown_item_selected: roles.value.filter(e => e.slug != 'admin')[0].value,
                                            // required: true,
                                        },
                                        {
                                            name: "phone",
                                            title: TR.value.phone,
                                            field_type: "mask",
                                            input_mask: "+999 (99) 999-99-99",
                                        },
                                        {
                                            name: "about",
                                            title: TR.value.about,
                                            field_type: "textarea",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            // grouping: false,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let formData = new FormData();

                                                        // if( typeof e.image == 'object' )
                                                        if( e.image != null && typeof e.image === 'object' ){
                                                            formData.append("upload_image", e.image);
                                                        }

                                                        let user_data = {
                                                            username: e.username,
                                                            password: e.password,
                                                            firstname: e.firstname,
                                                            lastname: e.lastname,
                                                            roles_id: e.roles_id,
                                                            email: e.email,
                                                            phone: e.phone,
                                                            about: e.about,
                                                            status: e.status ? 1 : 0
                                                        };
                                                        if( e && e.password && e.password != '' && e.password == e.password1 )
                                                            user_data.password = e.password;

                                                        if( e.image != null && typeof e.image !== 'object' )
                                                            user_data.image = e.image;

                                                        formData.append("data", JSON.stringify(user_data));

                                                        await ajax({
                                                            url: store.getUsers(),
                                                            method: 'post',
                                                            // content_type: 'application/json; charset=UTF-8',
                                                            data: formData,
                                                            success: (x) => {
                                                                let res1 = x.data || null;
                                                                if ( x && x.status == 200) {
                                                                    // res1.create_date = new Date(res1.create_date);
                                                                    tableData.value.unshift(res1);
                                                                    G.alert.success(TR.value.msg_add_success);
                                                                    G.closeModal(res);
                                                                }
                                                                // else{
                                                                //     G.alert.error(res.detail);
                                                                // }
                                                            },
                                                            // error: (x) => {
                                                            //     // var res = x.response || {};
                                                            //     // if( res && res.status == 422 ){
                                                            //     //     G.alert.warning(G.getErrorMessages(res.data.detail));
                                                            //     // }
                                                            //     // else{
                                                            //     //     G.alert.error(TR.value.msg_add_failed);
                                                            //     // }
                                                            // }
                                                        });
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        }
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotAdmin(),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_remove_user, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getUsersUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                            G.alert.success(res.detail);
                                        },
                                        // error: (e) => {
                                        //     let res = e.response || null;
                                        //     G.alert.error(G.getErrorMessages(res.data.detail));
                                        // }
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} });
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            private: e => G.hideAdminRecord(e),
                            // private: (data) => {
                            //     return G.privateIfNotPermission("update") === false ? ((data.role.slug != 'admin' && data.roles_id === G.token_data().roles_id) ? false : ((data.role.slug == 'admin' && data.roles_id !== G.token_data().roles_id) ? true : false)) : true;
                            // },
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `${TR.value.username}: <span class="text-danger">${data.username}</span>`, // - ${G.formatLocale(new Date(data.create_date))}`,
                                    modal_width: 35,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        {
                                            name: "username",
                                            title: TR.value.username,
                                            value: (e) => e.username,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "password",
                                            title: TR.value.users_password,
                                            field_type: "password",
                                        },
                                        {
                                            name: "password1",
                                            title: TR.value.users_repeat_password,
                                            field_type: "password",
                                        },
                                        {
                                            name: "email",
                                            title: TR.value.email,
                                            value: (e) => e.email,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "firstname",
                                            title: TR.value.firstname,
                                            value: (e) => e.firstname,
                                            field_type: "text",
                                        },
                                        {
                                            name: "lastname",
                                            title: TR.value.lastname,
                                            value: (e) => e.lastname,
                                            field_type: "text",
                                        },
                                        {
                                            name: "roles_id",
                                            title: TR.value.role,
                                            value: (e) => e.roles_id,
                                            field_type: "dropdown",
                                            dropdown_items: roles.value,
                                            dropdown_item_selected: data.roles_id,
                                            // required: true,
                                        },
                                        {
                                            name: "phone",
                                            title: TR.value.phone,
                                            value: (e) => e.phone,
                                            field_type: "mask",
                                            input_mask: "(99) 999-99-99",
                                        },
                                        {
                                            name: "about",
                                            title: TR.value.about,
                                            value: (e) => e.about,
                                            field_type: "textarea",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status > 0 ? true : false,
                                            field_type: "switch",
                                            // grouping: false,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.dateToStr(e.create_date, 'datetime'),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let formData = new FormData();
                                                        if( e.image != data.image && typeof e.image === 'object' ){
                                                            formData.append("upload_image", e.image);
                                                        }
                                                        let user_data = {
                                                            username: e.username,
                                                            firstname: e.firstname,
                                                            lastname: e.lastname,
                                                            roles_id: e.roles_id,
                                                            email: e.email,
                                                            phone: e.phone,
                                                            about: e.about,
                                                            status: e.status ? 1 : 0,
                                                        };
                                                        if( e && e.password && e.password != '' && e.password == e.password1 ){
                                                            user_data.password = e.password;
                                                        }

                                                        if( e.image != null && e.image != data.image && typeof e.image !== 'object' ){
                                                            user_data.image = e.image;
                                                        }

                                                        formData.append("data", JSON.stringify(user_data));

                                                        await ajax({
                                                            url: store.getUsersUpdate(data.id),
                                                            method: 'patch',
                                                            // content_type: 'application/json; charset=UTF-8',
                                                            // token: `${b}.${a1[1]}.${a1[2]}`,
                                                            data: formData,
                                                            success: (x) => {
                                                                let res1 = x.data || null;
                                                                if (res1) {
                                                                    // res1.create_date = new Date(res1.create_date);
                                                                    tableData.value.forEach(
                                                                        (s) => { if ( s.id === res1.id ) { s = res1; } }
                                                                    );
                                                                    for (let a in res1) {
                                                                        data[a] = res1[a];
                                                                    }
                                                                    G.alert.success(TR.value.msg_update_success);
                                                                    G.closeModal(res);
                                                                }
                                                            },
                                                            // error: (x) => {
                                                            //     var res1 = x.response || {};
                                                            //     if( res1.status == 422 ){
                                                            //         G.alert.warning(G.getErrorMessages(res1.data.detail));
                                                            //     }
                                                            //     else
                                                            //         G.alert.warning(res1.data.detail);
                                                            // }
                                                        });
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            private: e => G.hideAdminRecord(e),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getUsersActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data;
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        // banner_table_ref.value.loadLazyData();
                                        res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime']));
                                        tableData.value.forEach(
                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                        );
                                        for (let a in res) {
                                            data[a] = res[a];
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: "email",
                        //     value: "email",
                        //     title: TR.value.email,
                        //     exportable: true,
                        //     sortable: true,
                        //     showFilterMatchModes: true,
                        //     // filter: true,
                        //     // data_type: "text",
                        //     // filter_placeholder: TR.value.code,
                        // },
                        // {
                        //     name: "image",
                        //     value: (e) => `<img
                        //                             src="${
                        //                                 e.image
                        //                                     ? e.image
                        //                                     : "/assets/img/noimg.png"
                        //                             }"
                        //                             alt="${e.image}"
                        //                             class="border img-circle-cover"
                        //                         />`,
                        //     title: TR.value.image,
                        //     exportable: false,
                        //     sortable: false,
                        //     filter: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => `<img src="${
                                                        e.image
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    alt="${e.image}"
                                                    class="border img-circle-cover"
                                                />`,
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "username",
                            value: (e) => e.username,
                            title: `${TR.value.username}`,
                        },
                        {
                            name: "firstname",
                            value: (e) => e.firstname,
                            title: `${TR.value.firstname}`,
                        },
                        {
                            name: "lastname",
                            value: (e) => e.lastname,
                            title: `${TR.value.lastname}`,
                        },
                        {
                            name: "roles_id",
                            value: (e) => e.role.name,
                            title: `${TR.value.role}`,
                            filters: {
                                operator: "or",
                                constraints: [
                                    { value: null, matchMode: FilterMatchMode.EQUALS },
                                    // { value: null, matchMode: 'equals' },
                                ],
                            },
                            data_type: "customFilter",
                            filter_field: "roles_id",
                            filter_mode: "dropdown",
                            dropdown_items: roles.value,
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            return {
                TR,
                user_table_ref,
                roles,
                tableData,
                tableOptions,
            };
        },
    };
</script>

